var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMealProvided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Meal_Provided",
    "data-name": "Meal Provided",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ffeff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hot-meal",
    transform: "translate(474 184.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9904",
    "data-name": "Path 9904",
    d: "M24.3,10.572l-1.039-.518v0l0,.005-.007.015-.024.05c-.02.042-.047.1-.081.175-.066.148-.156.358-.256.616a12.724,12.724,0,0,0-.6,2.039c-.307,1.534-.409,3.805,1.188,5.4a3.6,3.6,0,0,1,.553,3.3,10.416,10.416,0,0,1-.489,1.661c-.082.214-.156.385-.207.5-.026.057-.046.1-.059.128l-.014.029,0,0L24.3,24.5c1.038.519,1.039.518,1.039.518v0l0,0L25.354,25l.024-.05c.02-.042.047-.1.081-.175.066-.148.156-.358.256-.616a12.725,12.725,0,0,0,.6-2.039c.307-1.534.409-3.805-1.188-5.4a3.6,3.6,0,0,1-.553-3.3,10.415,10.415,0,0,1,.489-1.661c.082-.214.156-.385.207-.5.026-.057.046-.1.059-.128l.014-.029,0,0Z",
    transform: "translate(2.915 0)",
    fill: "#c3504f",
    stroke: "#c3504f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9905",
    "data-name": "Path 9905",
    d: "M4,29.161A1.161,1.161,0,0,1,5.161,28H49.276a1.161,1.161,0,0,1,0,2.322H45.793c0,5.129-4.158,18.278-9.287,18.278H17.931c-5.129,0-9.287-13.149-9.287-18.278H5.161A1.161,1.161,0,0,1,4,29.161Zm6.966,1.161H43.471c0,3.847-3.119,15.956-6.966,15.956H17.931C14.084,46.278,10.966,34.169,10.966,30.322Z",
    transform: "translate(0 2.888)",
    fill: "#c3504f",
    stroke: "#c3504f",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9906",
    "data-name": "Path 9906",
    d: "M15.359,12.441s0,0,.963.649l.963.649-.014.022c-.013.021-.035.055-.062.1-.055.091-.134.228-.223.4a6.722,6.722,0,0,0-.522,1.31,2.032,2.032,0,0,0,.55,2.392,4.326,4.326,0,0,1,1.409,4.863,9.035,9.035,0,0,1-.7,1.774c-.115.222-.22.4-.3.531-.039.064-.071.115-.095.152l-.024.037,0,.007-.009.014,0,0v0s0,0-.963-.648-.963-.649-.963-.649l.014-.022c.013-.021.035-.055.062-.1.055-.091.134-.228.223-.4a6.719,6.719,0,0,0,.522-1.31,2.032,2.032,0,0,0-.55-2.392,4.326,4.326,0,0,1-1.409-4.863,9.039,9.039,0,0,1,.7-1.774c.115-.222.22-.4.3-.531.039-.064.071-.115.095-.152l.029-.044.009-.014,0,0Zm20.7.649c-.962-.65-.963-.649-.963-.649l0,0,0,0-.009.014-.029.044c-.024.037-.056.088-.095.152-.077.128-.182.309-.3.531a9.038,9.038,0,0,0-.7,1.774,4.326,4.326,0,0,0,1.409,4.863,2.032,2.032,0,0,1,.55,2.392,6.72,6.72,0,0,1-.522,1.31c-.089.171-.168.308-.223.4-.028.046-.049.079-.062.1l-.014.022s0,0,.963.649.963.648.963.648v0l0,0,.009-.014.018-.028.01-.016c.024-.037.056-.088.095-.152.077-.128.182-.309.3-.531a9.035,9.035,0,0,0,.7-1.774,4.326,4.326,0,0,0-1.409-4.863,2.032,2.032,0,0,1-.55-2.392,6.723,6.723,0,0,1,.522-1.31c.089-.171.168-.308.223-.4.028-.045.049-.079.062-.1l.014-.022Z",
    transform: "translate(1.61 0.384)",
    fill: "#c3504f",
    stroke: "#c3504f",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealProvided);
export default __webpack_public_path__ + "static/media/Meal-Provided.b32c866eec896442a2defb3b1174dc05.svg";
export { ForwardRef as ReactComponent };